import { configureStore } from '@reduxjs/toolkit'
import AuthenticationReducer from 'store/AuthenticationSlice'
import storage from 'redux-persist/lib/storage'
import { persistReducer, persistStore } from 'redux-persist'
import CustomizerReducer from 'store/customizer/CustomizerSlice'
import ProveidorReducer from 'store/ProveidorSlice'
import UserReducer from 'store/UserSlice'
import thunk from 'redux-thunk'

export const store = configureStore({
  reducer: {
    customizer: CustomizerReducer,
    credentials: persistReducer({ key: 'credentials', storage }, AuthenticationReducer),
    proveidor: persistReducer({ key: 'proveidor', storage }, ProveidorReducer),
    user: persistReducer({ key: 'user', storage }, UserReducer),
  },
  devTools: process.env.NODE_ENV !== 'production',
  middleware: [thunk],
})

export const persistor = persistStore(store)
